import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}sellers/vatRates?SellerIds=${COMMON_QUERY_PARAMS.SELLER_IDS}`;

interface GetVatRateBySellerIdsArgs {
  sellerIds: string[];
}

export const getVatRateBySellerIdsQuery = async (
  payload: GetVatRateBySellerIdsArgs,
): Promise<
  BackResponse<{ sellerId: string; vatRate: number }[]> | BackResponseFailure
> => {
  try {
    const { sellerIds } = payload;
    const url = buildUrl(
      ENDPOINT.replace(
        COMMON_QUERY_PARAMS.SELLER_IDS,
        sellerIds.join('&SellerIds='),
      ),
    );

    return await apiCall<BackResponse<{ sellerId: string; vatRate: number }[]>>(
      url,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
